export const MAX_LOOP_DELAY_MS = 10000
export const LOOP_DELAY_SLIDER_MAX = 1000

const clamp = (value, min, max) => Math.min(max, Math.max(min, value))

export function loopDelayRawToMs(rawValue) {
  const ratio = clamp(Number(rawValue) / LOOP_DELAY_SLIDER_MAX, 0, 1)
  const exact = ratio > 0 ? Math.max(1, MAX_LOOP_DELAY_MS * ratio ** 2.45) : 0
  if (exact < 100) return Math.round(exact)
  if (exact < 500) return Math.round(exact / 5) * 5
  if (exact < 2000) return Math.round(exact / 10) * 10
  if (exact < 5000) return Math.round(exact / 25) * 25
  return Math.round(exact / 50) * 50
}
